import { useMemo } from 'react';

import type { CardOptions } from '@atlaskit/editor-common/card';
import type { LinkingOptions } from '@atlaskit/editor-common/types';

import { useSmartCards } from './useSmartCards';

type AkEditorLinkingProp = { linking: LinkingOptions };

export const useLinkingOptions = (
	cardOptions?: Partial<CardOptions>,
	isChromelessEditor: boolean = false,
): AkEditorLinkingProp => {
	const baseSmartLinks = useSmartCards(isChromelessEditor);

	return useMemo<AkEditorLinkingProp>(
		() => ({
			linking: {
				smartLinks: { ...baseSmartLinks, ...cardOptions },
			},
		}),
		[baseSmartLinks, cardOptions],
	);
};
